import {
    GET_SERVICE_LISTING,
    GET_SERVICE_LISTING_SUCCESS,
    GET_SERVICE_LISTING_FAIL,
    GET_SERVICE_DETAILS,
    GET_SERVICE_DETAILS_SUCCESS,
    GET_SERVICE_DETAILS_FAIL,
    ADD_SERVICE,
    ADD_SERVICE_SUCCESS,
    ADD_SERVICE_FAIL,
    UPDATE_SERVICE,
    UPDATE_SERVICE_SUCCESS,
    UPDATE_SERVICE_FAIL,
    DELETE_SERVICE,
    DELETE_SERVICE_SUCCESS,
    DELETE_SERVICE_FAIL,
    BULK_DELETE_SERVICE,
    BULK_DELETE_SERVICE_SUCCESS,
    BULK_DELETE_SERVICE_FAIL,
    EXPORT_SERVICE,
    EXPORT_SERVICE_SUCCESS,
    EXPORT_SERVICE_FAIL,
    RESET_SERVICE_STATE,
    RESET_SERVICE_ATTACHMENT_STATE,
} from "./actionTypes";

export const getServiceListing = service => ({
    type: GET_SERVICE_LISTING,
    payload: service,
});

export const getServiceListingSuccess = service => ({
    type: GET_SERVICE_LISTING_SUCCESS,
    payload: service,
});

export const getServiceListingFail = error => ({
    type: GET_SERVICE_LISTING_FAIL,
    payload: error,
});

export const getServiceDetails = serviceId => ({
    type: GET_SERVICE_DETAILS,
    payload: serviceId,
});

export const getServiceDetailsSuccess = service => ({
    type: GET_SERVICE_DETAILS_SUCCESS,
    payload: service,
});

export const getServiceDetailsFail = error => ({
    type: GET_SERVICE_DETAILS_FAIL,
    payload: error,
});

export const createService = service => ({
    type: ADD_SERVICE,
    payload: service,
});

export const createServiceSuccess = service => ({
    type: ADD_SERVICE_SUCCESS,
    payload: service,
});

export const createServiceFail = error => ({
    type: ADD_SERVICE_FAIL,
    payload: error,
});

export const updateService = service => ({
    type: UPDATE_SERVICE,
    payload: service,
});

export const updateServiceSuccess = service => ({
    type: UPDATE_SERVICE_SUCCESS,
    payload: service,
});

export const updateServiceFail = error => ({
    type: UPDATE_SERVICE_FAIL,
    payload: error,
});

export const deleteService = serviceId => ({
    type: DELETE_SERVICE,
    payload: serviceId,
});

export const deleteServiceSuccess = serviceId => ({
    type: DELETE_SERVICE_SUCCESS,
    payload: serviceId,
});

export const deleteServiceFail = error => ({
    type: DELETE_SERVICE_FAIL,
    payload: error,
});

export const bulkDeleteService = serviceId => ({
    type: BULK_DELETE_SERVICE,
    payload: serviceId,
});

export const bulkDeleteServiceSuccess = serviceId => ({
    type: BULK_DELETE_SERVICE_SUCCESS,
    payload: serviceId,
});

export const bulkDeleteServiceFail = error => ({
    type: BULK_DELETE_SERVICE_FAIL,
    payload: error,
});

export const exportService = data => ({
    type: EXPORT_SERVICE,
    payload: data
});

export const exportServiceSuccess = data => ({
    type: EXPORT_SERVICE_SUCCESS,
    payload: data,
});

export const exportServiceFail = error => ({
    type: EXPORT_SERVICE_FAIL,
    payload: error,
});

//reset
export const resetServiceState = () => {
    return {
        type: RESET_SERVICE_STATE,
    }
}

//reset attachment
export const resetServiceAttachmentState = () => {
    return {
        type: RESET_SERVICE_ATTACHMENT_STATE,
    }
}

